import React from 'react';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';
import CallToAction from '../components/CallToAction';
import useSeo from '../hooks/useSeo';

const values = [
  {
    title: 'Practical over flashy',
    text: 'We choose proven parts, stacks and models that fit your budget and timeline, and we avoid technology for its own sake.',
  },
  {
    title: 'Transparent by default',
    text: 'You get regular demos, honest estimates and early warning when something changes.',
  },
  {
    title: 'Built to last',
    text: 'Clean schematics, documented code and tested firmware mean your product can outlive the engagement.',
  },
];

const disciplines = [
  'Analog & digital circuit design',
  'PCB layout',
  'Embedded C / C++ & Rust',
  'Embedded Linux',
  'Wireless & IoT protocols',
  'Cloud infrastructure',
  'Web & mobile development',
  'Machine learning & LLMs',
  'Computer vision',
  'Security best practices',
];

const About = () => {
  useSeo('/about');

  return (
    <>
      <PageHeader eyebrow="About" title="A technology lab for connected products.">
        Gomagen Labs is based in Moncton, New Brunswick. We help startups and established businesses across Atlantic
        Canada turn ideas into working technology, from the circuit board to the cloud to the AI running on top.
      </PageHeader>

      <section className="container-site grid gap-14 py-24 lg:grid-cols-2">
        <Reveal>
          <h2 className="font-display text-3xl font-bold text-white">Why we exist</h2>
          <div className="mt-6 space-y-5 leading-relaxed text-slate-400">
            <p>
              Building a connected product usually means coordinating an electronics shop, a firmware contractor, a
              cloud team, an app agency and now an AI specialist. Each piece gets built well, but often in
              isolation, and the problems show up where they meet.
            </p>
            <p>
              We started Gomagen Labs to close those gaps. With one team covering hardware, software and data, the
              whole system is designed together, prototypes are ready sooner and fewer surprises reach production.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="card p-8">
          <h2 className="eyebrow">Disciplines</h2>
          <ul className="mt-6 flex flex-wrap gap-2">
            {disciplines.map((item) => (
              <li key={item} className="rounded-full border border-ink-600 px-3.5 py-1.5 text-sm text-slate-300">
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
      </section>

      <section className="border-t border-ink-700 bg-ink-900/50 py-24">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">How we operate</p>
            <h2 className="mt-4 font-display text-3xl font-bold text-white md:text-4xl">What you can count on.</h2>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {values.map((value, i) => (
              <Reveal key={value.title} delay={i * 0.08} className="border-l-2 border-signal-400 pl-6">
                <h3 className="font-display text-xl font-semibold text-white">{value.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{value.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
};

export default About;
